//import { formatPostalCode } from '@/helpers/string';
// TODO: Move to config (lambda) and derive fromprocessSteps //
const processPaths = {
  brussels: [
    //'chargerIdentification',
    'project',               'location',
    'contacts',              'approval',
    'permitting',            'contradictoryInventory',
    'works',                 'roadPermit',
    'grid',                  'siteWorks',
    'gridConnectionRequest', 'dsoAddress',
    'connection',            'communications',
    'ean',
    'certification',         'gridConnection',
    'tests',                 'commissioning',
    'projectCompletion',     'validation'
  ],
  get wallonia () { return this.brussels },
  takeover: ['location', 'planning', 'sat', 'repairment', 'signature', 'commissioning', 'completion']
}

const setAvailableModelProps = (data, processType) => {
  return Object.fromEntries((processPaths[processType] || [])
          .filter(key => Object.hasOwn(data, key))
          .map(path => [path, data[path]]))
}
/**
 * A Location is part of Realisation record
 *  One Realisation record can hold multiple Locations
 */
class Location {
  constructor({ data, copy, processType }) {
    let model = {};

    // short circuit making copies
    if (copy || this.LooksAndQuacksLikeCopy({ data })) {
      model = this.makePlainCopy({ data });
    } else {
      model = this.commonStructure({ data, processType });
    }

    //
    Object.keys(model).forEach(key => {
      this[key] = model[key];
    });
  }
  LocationCopy({ version }) {
    let oldData = JSON.parse(JSON.stringify(this));

    let data = {
      ...oldData,
      Municipality: oldData.Municipality
    };

    data.version = version;

    return new Location({ data, copy: true });
  }

  getDocTypeCount({ doctype }) {
    return this.hasDocOfType({ doctype }) ? this.Docs[doctype].length : 0;
  }
  LooksAndQuacksLikeCopy({ data }) {
    return data instanceof Location;
  }
  commonStructure({ data, processType }) {

    // const countryMap = {
    //   Netherlands: 'Nederland',
    //   Belgium: 'België'
    // };
    /**
     * Data model mapping
     */
    const isTakeover = processType.value === 'takeover'

    let model = {
      version: data.version || 1,

      raw: JSON.parse(JSON.stringify(data)),
      project: data.project || {},
      location: data.location || (isTakeover ? { address: {} } : {
        address: {},
        chargingStation: {}
      }),
      contacts: data.contacts || {
        extra: []
      },
      chargerIdentification: data.chargerIdentification || [],
      ...(isTakeover ? {
        planning:      data.planning      || {},
        sat:           data.sat           || {},
        repairment:    data.repairment    || {},
        signature:     data.signature     || {},
        commissioning: data.commissioning || {},
        completion:    data.completion    || {}
      } : {}),
      ...setAvailableModelProps(data, processType.value),

      /****************************************************************************
       * Documents
       */

      Docs: data.Docs
        ? {
            fiche: data.Docs.fiche || [],
            ficheEquans: data.Docs.ficheEquans || [],
            urbanPermit: data.Docs.urbanPermit || [],
            gridConnectionOffer: data.Docs.gridConnectionOffer || [],
            gridConnectionInvoice: data.Docs.gridConnectionInvoice || [],
            gridStudy: data.Docs.gridStudy || [],
            roadPermit: data.Docs.roadPermit || [],
            contradictoryInventoryReport: data.Docs.contradictoryInventoryReport || [],
            secondRoadPermit: data.Docs.secondRoadPermit || [],
            installationReport: data.Docs.installationReport || [],
            referenceReport: data.Docs.referenceReport || [],
            certificationReport: data.Docs.certificationReport || [],
            gridConnectionReport: data.Docs.gridConnectionReport || [],
            gridConnectionApproval: data.Docs.gridConnectionApproval || [],
            paintingStatPermitUpload: data.Docs.paintingStatPermitUpload || [],
            satReport: data.Docs.satReport || [],
            migrationReport: data.Docs.migrationReport || [],
            inventoryReport: data.Docs.inventoryReport || [],
            TopView: data.Docs.TopView || [],
            SideView: data.Docs.SideView || [],
            asBuilt: data.Docs.asBuilt || []
          }
        : {
            fiche: [],
            ficheEquans: [],
            urbanPermit: [],
            gridConnectionOffer: [],
            gridConnectionInvoice: [],
            gridStudy: [],
            roadPermit: [],
            contradictoryInventoryReport: [],
            secondRoadPermit: [],
            installationReport: [],
            referenceReport: [],
            certificationReport: [],
            gridConnectionReport: [],
            gridConnectionApproval: [],
            paintingStatPermitUpload: [],
            satReport: [],
            migrationReport: [],
            inventoryReport: [],
            TopView: [],
            SideView: [],
            asBuilt: []
          },

      /**
       * Mail log
       */
      MailLog: data.maillog || {}
    };

    return model;
  }
  makePlainCopy({ data }) {
    data = JSON.parse(JSON.stringify(data)); // data.raw

    // Only add raw if not yet set on original
    if (!data.raw) {
      data.raw = JSON.parse(JSON.stringify(data));
    }

    return data;
  }
}

export default Location;
